import request from '../utils/request';

//实名认证
export function auth(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontCommon/realNameVerification',
    method: 'POST',
    data: formData,
  });
}
